import {
  RAFFLE_AVAILABLE_TABS_REQUEST,
  RAFFLE_AVAILABLE_TABS_SUCCESS,
  RAFFLE_AVAILABLE_TABS_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RAFFLE_AVAILABLE_TABS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case RAFFLE_AVAILABLE_TABS_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };
    case RAFFLE_AVAILABLE_TABS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
